import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Docusign from "../Docusign";
import FormHistory from "../forms/FormHistory";
import FormsList from "../forms/FormsList";
import { getFormContainersAndVersions } from "../services/soar";

function FormsTab({ contactID, clientProgram, careTeam }) {
  const [docusignData, setDocusignData] = useState([]);
  const [formsInfo, setFormsInfo] = useState([]);

  // const docusignFormsToShow = JSON.parse(
  //   clientProgram["unit.sor_safyportalconfig"]
  // )["docusignForms"]
  //   ? JSON.parse(clientProgram["unit.sor_safyportalconfig"])["docusignForms"]
  //   : [];

  useEffect(() => {
    const getContainersAndVersions = async () => {
      const formsInfoResults = await getFormContainersAndVersions();
      if (formsInfoResults.includes("Error:")) {
        toast.error(`Error encountered in Forms Info - ${formsInfoResults} `);
      } else {
        setFormsInfo(sort(formsInfoResults, "FormName"));
      }
    };

    getContainersAndVersions();
  }, []);

  const sort = (array, field) => {
    const newArray = array.sort((a, b) => {
      const nameA = a[field].toUpperCase(); // ignore upper and lowercase
      const nameB = b[field].toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });
    return newArray;
  };

  // const setExpanded = (section) => {
  //   const obj = { ...sectionsExpanded };
  //   if (obj[section] !== undefined)
  //     obj[section].expanded = !obj[section].expanded;
  //   else obj[section] = { expanded: true };
  //   setSectionsExpanded(obj);
  // };

  const addToDocusignList = (form) => {
    let forms = [form, ...docusignData];
    setDocusignData(forms);
  };

  const clearDocusignList = () => {
    setDocusignData([]);
  };

  return (
    <>
      <FormsList
        clientProgram={clientProgram}
        contactID={contactID}
        addToDocusignList={addToDocusignList}
        formsInfo={formsInfo}
      />
      <div className="bg-safy1-3 rounded p-2">
        <FormHistory
          clientProgramId={clientProgram.ccx_client_programid}
          clientName={clientProgram["con.fullname"]}
          contactId={contactID}
        />
      </div>
      <Docusign
        careTeam={careTeam}
        clientProgram={clientProgram}
        forms={docusignData}
        clearDocusignList={clearDocusignList}
      />
    </>
  );
}

export default FormsTab;
